import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import scrollTo from 'commons/scrollTo';
import getHeightOfElement from 'commons/getHeightOfElement';
import getTopPositionOfElement from 'commons/getTopPositionOfElement';
import getBottomPositionOfElement from 'commons/getBottomPositionOfElement';
import browserStorage from 'components/consumer/browser-storage';
import IconCheck from 'components/icons/iconCheck';
import JBImage from 'components/essentials/JBImage';
import CollectionsGridDesktopPlaceholders from './CollectionsGridDesktopPlaceholders';
const STICKY_HEADER_HEIGHT = 60;
const CollectionsGridDesktop = t0 => {
  const $ = _c(7);
  const {
    collections,
    loading,
    selectedCollection,
    setSelectedCollection
  } = t0;
  const collectionsGridRef = React.useRef(null);
  const selectedCollectionRef = React.useRef(null);
  let t1;
  if ($[0] !== collections || $[1] !== loading || $[2] !== selectedCollection || $[3] !== setSelectedCollection) {
    t1 = loading ? <CollectionsGridDesktopPlaceholders /> : collections.map(collection => {
      const isSelected = selectedCollection === collection;
      return collection.images[0] && <div className={classNames("group/collection-grid-item cursor-pointer", "focus:outline-0", "focus-visible:[outline-style:auto] focus-visible:outline-2 focus-visible:outline-brand focus-visible:outline-offset-0 focus-visible:p-[5px]")} key={collection.id} role="button" tabIndex="0" onClick={() => {
        setSelectedCollection(collection);
        setTimeout(() => {
          if (selectedCollectionRef.current && collectionsGridRef.current) {
            const selectedElement = selectedCollectionRef.current;
            const wrapperElement = collectionsGridRef.current;
            const bottomOfWrapper = getBottomPositionOfElement(wrapperElement);
            const topOfElement = getTopPositionOfElement(selectedElement);
            const heightOfElement = getHeightOfElement(selectedElement);
            const bottomOfElement = getBottomPositionOfElement(selectedElement);
            const isItemOnBottomRow = bottomOfWrapper - bottomOfElement < heightOfElement;
            const topOfElementWithPadding = topOfElement - 25 + STICKY_HEADER_HEIGHT;
            const targetScrollPosition = isItemOnBottomRow ? topOfElementWithPadding - heightOfElement * 0.6 : topOfElementWithPadding;
            scrollTo({
              left: 0,
              top: targetScrollPosition,
              behavior: "smooth"
            });
            browserStorage().setItem("scrollPosition.collections", targetScrollPosition);
          }
        }, 200);
      }}><div ref={isSelected ? selectedCollectionRef : null} className={classNames("relative [transition:transform_.25s_ease-in-out]", "before:[content:\"\"] before:block before:pt-[100%]", "[&_img]:top-0 [&_img]:left-0 [&_img]:h-full [&_img]:w-full [&_img]:absolute [&_img]:rounded", "group-hover/collection-grid-item:md:!scale-105 group-hover/collection-grid-item:min-[1600px]:!transform-[scale(1.03)]", {
          "[&_img]:shadow-[0_0_0_3px_#fff,0_0_0_5px_#262626]": isSelected
        })}><JBImage src={collection.images[0].url} fallbackSrc={collection.images[0].url} alt={collection?.category_meta_description ?? ""} sizes="25vw" />{isSelected && <div className="items-center bg-gray-dark flex h-8 justify-center absolute right-[-5px] top-[-5px] w-8 md:rounded-tr [&_svg]:h-4 [&_svg]:w-4 [&_svg_path]:fill-white [&_svg_path]:stroke-[#fff]"><IconCheck /></div>}</div><h4 className="text-xl font-bold text-gray mt-[1.375rem] mb-[.4rem]">{collection.name}</h4><div className="text-sm mb-10">{collection.category_description || collection.category_meta_description}</div></div>;
    });
    $[0] = collections;
    $[1] = loading;
    $[2] = selectedCollection;
    $[3] = setSelectedCollection;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <div className="max-[767px]:hidden grid gap-[2px] grid-cols-[repeat(auto-fill,minmax(120px,1fr)_)] relative md:gap-8 md:ml-[3.333vw] md:px-0 md:py-8 md:grid-cols-[repeat(auto-fill,minmax(20vw,1fr)_)]" ref={collectionsGridRef}>{t1}</div>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
CollectionsGridDesktop.propTypes = {
  collections: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    category_description: PropTypes.string,
    category_meta_description: PropTypes.string,
    images: PropTypes.arrayOf(PropTypes.shape({
      url: PropTypes.string.isRequired
    })).isRequired
  })).isRequired,
  loading: PropTypes.bool,
  selectedCollection: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    category_description: PropTypes.string,
    category_meta_description: PropTypes.string,
    images: PropTypes.arrayOf(PropTypes.shape({
      url: PropTypes.string.isRequired
    })).isRequired
  }),
  setSelectedCollection: PropTypes.func
};
export default CollectionsGridDesktop;